import React from 'react';
import TryhardH2 from '../../../TryhardMarkups';
import BoogieBoardCard from './BoogieBoardCard';
import { AnimatePresence, motion } from 'motion/react';
import { BounceTransitionWrap, PageTransitions } from '../../../../../../../utils/transitions';

const TryhardBoards: React.FC = () => {
    return (
        <motion.div 
            layout
            variants={PageTransitions}
            initial='initial'
            animate='animate'
            exit='exit'
            className='flex flex-col items-center gap-y-2'
        >
            <AnimatePresence>
                <BounceTransitionWrap key={0}>
                    <TryhardH2>Boards</TryhardH2>
                </BounceTransitionWrap>
                <BounceTransitionWrap key={1} delay={.05}>
                    <p className='max-w-96 text-center bg-white bg-opacity-30 px-4 py-2 shadow-lg rounded-lg'>Our <span className='font-semibold text-red-950'>LCD Life Pad</span> is excellent for doodling, jotting down notes, and keeping track of your games!</p>
                </BounceTransitionWrap>
                <BounceTransitionWrap key={2} delay={.1}>
                    <div className='py-4'>
                        <BoogieBoardCard />
                    </div>
                </BounceTransitionWrap>
            </AnimatePresence>
        </motion.div>
    )
}

export default TryhardBoards;